<template>
  <v-container>
    <div class="StartSessie">
      <h1>Start sessie</h1>
      <div v-show="!geactiveerd">
        <v-text-field
          label="Cliëntnummer"
          v-model="client.Clientnummer"
          maxlength="20"
          v-show="!clientopgehaald"
        ></v-text-field>
        <v-btn
          @click="getClient()"
          v-show="!clientopgehaald && rechten && rechten.SessieStarten"
          color="primary"
        >
          Ophalen
        </v-btn>
        <span v-show="!clientopgehaald && rechten && !rechten.SessieStarten"
          >U heeft geen rechten om een sessie te starten</span
        >
      </div>
      <v-card v-show="clientopgehaald && !geactiveerd">
        <v-card-title>Cliëntgegevens</v-card-title>
        <v-card-subtitle>
          <span v-show="clientopgehaald"
            >{{ client.Clientnummer }}
            <span v-if="client.DatumVorigeSessie"
              >(laatste keer ingevuld op
              <router-link
                :to="{
                  name: 'rapportclient',
                  query: { clientnummer: client.Clientnummer },
                }"
                target="_blank"
                >{{ client.DatumVorigeSessie }}</router-link
              >)</span
            >
            <span v-if="!client.DatumVorigeSessie">(niet eerder ingevuld)</span>
          </span>
        </v-card-subtitle>
        <v-card-text>
          <div class="caption">Welke medewerkers waren betrokken?</div>
          <v-item-group class="mt-3 mb-3">
            <v-item v-for="(m, i) in client.Medewerkers" :key="i">
              <v-checkbox
                :label="m.Naam"
                v-model="m.Checked"
                class="mt-0 mb-0 pt-0 mb-0"
                dense
                hide-details
              ></v-checkbox>
            </v-item>
          </v-item-group>

          <v-select
            v-model="client.LocatieId"
            :items="locaties"
            item-text="Naam"
            item-value="Id"
            label="Op welke locatie is de cliënt geweest?"
          >
          </v-select>

          <v-select
            v-model="client.VragensetId"
            :items="vragensets"
            item-text="Naam"
            item-value="Id"
            label="Welke set vragen moet worden afgenomen?"
          >
          </v-select>

          <v-select
            v-model="client.ProvincieId"
            :items="provincies"
            item-text="Naam"
            item-value="Id"
            label="Woonprovincie cliënt"
          >
          </v-select>

          <v-select
            v-model="client.LeeftijdCategorieId"
            :items="leeftijdcategorieen"
            item-text="Naam"
            item-value="Id"
            label="Leeftijd cliënt"
          >
          </v-select>

          <v-radio-group v-model="client.Geslacht" label="Geslacht" row>
            <v-radio label="Man" value="M"></v-radio>
            <v-radio label="Vrouw" value="V"></v-radio>
            <v-radio label="Neutraal" value="N"></v-radio>
          </v-radio-group>

          <v-radio-group
            v-model="client.AuthMode"
            label="Hoe gaat de cliënt de vragen beantwoorden?"
            column
          >
            <v-radio label="Hier, op de 'hardware'-Vinnie" value="V"></v-radio>
            <v-radio
              label="Hier, op een computer of laptop"
              value="C"
            ></v-radio>
            <v-radio
              label="Thuis, de cliënt ontvangt een e-mail met activatie-link"
              value="E"
            ></v-radio>
          </v-radio-group>

          <v-select
            v-model="client.Token"
            :items="tokens"
            item-text="Naam"
            item-value="Id"
            label="Welk pasje heeft u de cliënt gegeven?"
            v-show="client.AuthMode == 'V'"
          >
          </v-select>
          <v-form ref="formemail" v-if="client.AuthMode == 'E'">
            <v-text-field
              label="Vul hier het emailadres van de cliënt in. Op dit adres ontvangt de cliënt de uitnodiging."
              v-model="client.Email"
              maxlength="250"
              outlined
              messages="Het emailadres wordt niet opgeslagen in het systeem i.v.m. privacy."
              :rules="[
                (v) => !!v || 'Vul een emailadres in.',
                (v) =>
                  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
                    v
                  ) || 'E-mailadres is niet geldig.',
              ]"
            ></v-text-field>
          </v-form>
          <v-checkbox
            label="Wettelijke vertegenwoordiging van toepassing"
            v-model="client.WettelijkeVertegenwoordiging"
            v-if="false"
          ></v-checkbox>
          <v-checkbox
            label="Getekende toestemmingsverklaring op papier aanwezig"
            v-model="client.GetekendeToestemmingsverklaring"
            v-if="false"
          ></v-checkbox>
          <v-form ref="formcheckboxen">
            <v-radio-group
              v-model="client.WettelijkeVertegenwoordiging"
              label="Wettelijke vertegenwoordiging van toepassing"
              :rules="[(v) => v != null || 'Kies ja of nee']"
            >
              <v-radio :value="true" label="Ja"></v-radio>
              <v-radio :value="false" label="Nee"></v-radio>
            </v-radio-group>

            <v-radio-group
              v-model="client.GetekendeToestemmingsverklaring"
              label="Getekende toestemmingsverklaring op papier aanwezig"
              :rules="[(v) => v != null || 'Kies ja of nee']"
            >
              <v-radio :value="true" label="Ja"></v-radio>
              <v-radio :value="false" label="Nee"></v-radio>
            </v-radio-group>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="activeer()" color="primary">Activeer</v-btn
          ><v-btn color="cancel" @click="annuleer()"> Annuleer </v-btn>
        </v-card-actions>
      </v-card>
      <div class="start-info" v-show="geactiveerd">
        <div v-show="client.AuthMode == 'V'">
          Nu kan de cliënt Vinnie activeren met het pasje "{{
            getTokenName()
          }}".
        </div>
        <div v-show="client.AuthMode == 'E'">
          Er is een e-mail gestuurd naar {{ client.Email }}. De cliënt kan thuis
          de vragen beantwoorden.
        </div>
        <div v-show="client.AuthMode == 'C'">
          <v-chip color="primary" outlined large class="text-h4 mt-2 mb-3">{{
            client.AuthCode
          }}</v-chip
          ><br />
          De cliënt kan met code {{ client.AuthCode }} de vragen beantwoorden.
          Schrijf deze code op een kaartje en geef het aan de cliënt mee.<br />
          <router-link
            v-if="client && client.AuthCode != ''"
            :to="{
              name: 'vragenlijstweb',
              params: { sessie: client.AuthCode },
              query: { e: '1' },
            }"
            target="_blank"
            >Direct naar vragenlijst</router-link
          >
        </div>
        <v-btn @click="annuleer()" class="mt-5" color="primary">Gereed</v-btn>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "StartSessie",
  props: {},
  data() {
    return {
      provincies: [],
      vragensets: [],
      locaties: [],
      tokens: [],
      leeftijdcategorieen: [],
      clientopgehaald: false,
      geactiveerd: false,
      sessienummer: "",
      rechten: null,
      client: {
        Medewerkers: [],
        Clientnummer: "",
        Geslacht: "M",
        Datum: null,
        LocatieId: null,
        ProvincieId: null,
        LeeftijdCategorieId: null,
        AuthMode: "V",
        Email: "",
        AuthCode: "",
      },
    };
  },
  methods: {
    getClient: function () {
      if (this.client.Clientnummer.length > 0) {
        this.$api
          .pClientGet({ Clientnummer: this.client.Clientnummer })
          .then((response) => {
            if (response.data.length > 0) {
              this.client = response.data[0];
              this.clientopgehaald = true;
              this.geactiveerd = false;
            }
          });
      } else {
        alert("Vul een cliëntnummer in.");
      }
    },
    activeer: function () {
      if (this.client.AuthMode == "E" && !this.$refs.formemail.validate()) {
        return;
      }

      if (this.client.Clientnummer && this.client.Clientnummer.length > 1) {
        if (this.$refs.formcheckboxen.validate()) {
          this.$api.pClientSave(this.client).then((response) => {
            this.geactiveerd = true;
            this.sessienummer = response.data[0].VragenSessieId;
          });
        }
      } else {
        alert("Vul een cliëntnummer in.");
      }
    },
    annuleer: function () {
      this.clientopgehaald = false;
      this.client.Clientnummer = "";
      this.geactiveerd = false;
    },
    getTokenName: function () {
      for (var i = 0; i < this.tokens.length; i++) {
        if (this.tokens[i].Id == this.client.Token) {
          return this.tokens[i].Naam;
        }
      }
      return "";
    },
    getRechten: function () {
      this.$api.pRechtenGet().then((response) => {
        this.rechten = response.data[0];
      });
    },
  },
  created: function () {
    this.$api.pProvinciesGet().then((response) => {
      this.provincies = response.data;
    });
    this.$api.pLocatiesGet().then((response) => {
      this.locaties = response.data;
    });
    this.$api.pVragensetsGet().then((response) => {
      this.vragensets = response.data;
    });
    this.$api.pLeeftijdCategorieenGet().then((response) => {
      this.leeftijdcategorieen = response.data;
    });
    this.$api.pMedewerkersGet().then((response) => {
      this.client.Medewerkers = response.data;
    });
    this.$api.pTokensGet().then((response) => {
      this.tokens = response.data;
    });
    this.getRechten();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
